module.exports = __webpack_public_path__ + "img/quickresume2.a31e2dc4.png";